<template>
  <div id="app-sidebar">
    <h1>{{ msg }}</h1>
    <ul>
      <li><router-link to="/">Home</router-link></li>
      <li><router-link to="/component_1">Component 1</router-link></li>
      <li><router-link to="/component_2">Component 2</router-link></li>
      <!-- <li><router-link :to="{'name': 'ImagePreloader','params': {'callback': imagePreloaderCallback, 'testProp': 'test value from sidebar component'}}">Image Preloader</router-link></li> -->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {
      msg: 'Sidebar',
      imagePreloaderCallback: function () {
        alert('From parent sidebar, image loaded function!!!')
      }
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #app #app-sidebar{
    width: 15vw;
    height: 100vh;
    background-color: yellow;
    border-left: 6px solid black;
    border-right: 6px solid black;
    padding: 2px;
    top: 0;
  }
  h1, h2 {
    font-weight: normal;
  }
  ul{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  li{
    list-style-type: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue